/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import * as sH from 'sanitize-html'
import { graphql, Link } from 'gatsby'
import scrollTo from 'gatsby-plugin-smoothscroll'

const Wrapper = styled.section`
  ${tw`max-w-7xl mx-auto px-4 pb-16`}
`
const Content = styled.div`
  ${tw`max-w-3xl mx-auto`}
  h2::after {
    content: '.';
    ${tw`text-primary`}
  }
`
const Index = styled.div`
  ${tw`flex items-start flex-col md:flex-row justify-center`}
`
const Title = styled.div`
  ${tw`text-gray-500 px-4 flex flex-row`}
`
const slash = '<span class="pl-5">/</span>'

const Button = styled(props => <button type="button" {...props} />)`
  ${tw`ml-10 md:ml-0 px-4`}
`
const PageLink = styled(props => <Link {...props} />)`
  ${tw`ml-10 md:ml-0 px-4`}
`

const InlineNav = ({ data }) => {
  const { title, links } = data

  return (
    <Wrapper>
      <Content>
        <Index>
          {title && (
            <Title
              dangerouslySetInnerHTML={{
                __html: sH(title) + slash,
              }}
            />
          )}
          {links.map(({ type, objId, text, link } = {}) => (
            <div key={text}>
              {type === 'inline'
                ? objId && (
                    <Button
                      onClick={() => scrollTo(`#${objId}`)}
                      dangerouslySetInnerHTML={{
                        __html: sH(text),
                      }}
                    />
                  )
                : link && (
                    <PageLink
                      to={link.url}
                      dangerouslySetInnerHTML={{
                        __html: sH(link.title),
                      }}
                    />
                  )}
            </div>
          ))}
        </Index>
      </Content>
    </Wrapper>
  )
}

export default InlineNav

InlineNav.propTypes = {
  data: PropTypes.object.isRequired,
  links: PropTypes.array,
  title: PropTypes.string,
}

export const InlineNavData = graphql`
  fragment InlineNav on WpPage_Pagebuilder_Layouts_InlineNav {
    fieldGroupName
    title
    links {
      type
      text
      link {
        url
        title
        target
      }
      objId
    }
  }
`
